// extracted by mini-css-extract-plugin
export default {"modalOverlay":"fA-z","modalContent":"gA-z","header":"hA-z","close":"iA-z"};